// extracted by mini-css-extract-plugin
export var noSpinners = "_nz-6";
export var percentageInput = "_nz-7";
export var variantColor1 = "_nz-0";
export var variantColor2 = "_nz-1";
export var variantColor3 = "_nz-2";
export var variantColor4 = "_nz-3";
export var variantColor5 = "_nz-4";
export var variantColor6 = "_nz-5";